import { render, staticRenderFns } from "./color.vue?vue&type=template&id=03291c06"
import script from "./color.vue?vue&type=script&lang=ts"
export * from "./color.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports